// extracted by mini-css-extract-plugin
export var archive = "archive-module--archive--28b62";
export var archiveHeader = "archive-module--archiveHeader--6a2d0";
export var archiveHeading = "archive-module--archiveHeading--ea89c";